import React from 'react'
import { Modal } from 'react-bootstrap';
import BaseBtn from '../../components/common/styled/BaseBtn'
import ModelBody from "./sub/ModelBody"
import BtnGroup from "./sub/BtnGroup"
import { createGlobalStyle } from 'styled-components';
import PropTypes from 'prop-types'

const GlobalStyle = createGlobalStyle`
  .SuccessModel {
    .modal-dialog {
      max-width: 460px;
      font-weight: 500;
      color: #333333;
      .text-cont {
        font-size: 20px;
        text-align: center;
      }
    }
  }
`

export default function SuccessModel(props) {
  return (
    <>
      <GlobalStyle></GlobalStyle>
      <Modal show={props.show} 
        className="SuccessModel"
        onHide={props.onHide}
      >
        <Modal.Body>
          <ModelBody>
            <div className="text-cont">
            {props.children}
            </div>
          </ModelBody>
          <BtnGroup>
            <BaseBtn width="150px" heigth="42px" onClick={props.onHide}>Confirm</BaseBtn>
          </BtnGroup>
        </Modal.Body>
      </Modal>
    </>
  )
}

SuccessModel.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
}